import { render, staticRenderFns } from "./ItemManualTax.vue?vue&type=template&id=1f89caac&scoped=true"
import script from "./ItemManualTax.vue?vue&type=script&lang=js"
export * from "./ItemManualTax.vue?vue&type=script&lang=js"
import style0 from "./ItemManualTax.vue?vue&type=style&index=0&id=1f89caac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f89caac",
  null
  
)

export default component.exports